




// import React, { useState, useEffect } from "react"; // Added useEffect for screenWidth
// import "../Caterings/Analysis.css"; // Import the CSS
// import { Link } from "react-router-dom"; // Import Link for navigation
// import axios from "axios";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     BarChart,
//     Bar,
//     LineChart,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     Legend,
//     ResponsiveContainer,
//     PieChart,
//     Pie,
//     Cell,
// } from "recharts";

// const Foodreports = () => {
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [stats, setStats] = useState(null);
//     const { showLoader, hideLoader } = useLoader();
//     // Handle screen resize
//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Fetch API data
//     useEffect(() => {
//         const fetchStats = async () => {
//             try {
//                 showLoader();
//                 const token = localStorage.getItem("authToken");
//                 if (!token) throw new Error("No auth token found. Please login.");

//                 const response = await axios.get(
//                     "https://backend.maamaas.com/food/api/orders/admin/statistics",
//                     {
//                         headers: {
//                             Authorization: `Bearer ${token}`,
//                             Accept: "application/json",
//                         },
//                     }
//                 );

//                 setStats(response.data);
//                 // console.log("API Response:", response.data);
//             } catch (err) {
//                 console.error("Failed to fetch statistics:", err);
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchStats();
//     }, []);

//     if (!stats) return <p>Loading statistics...</p>;

//     // Transform vendorSalesGrowth into an array of objects for LineChart
//     const transformSalesGrowth = (vendorSalesGrowth) => {
//         const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
//         const vendors = Object.keys(vendorSalesGrowth).filter((k) => k !== "days");

//         // If no vendor data, simulate a single vendor with incremental values
//         if (vendors.length === 0) {
//             return days.map((day, idx) => ({
//                 day,
//                 "Vendor 1": 50 + idx * 10, // starting at 50, increment 10 per day
//             }));
//         }

//         // If real data exists
//         return days.map((day, idx) => {
//             const row = { day };
//             vendors.forEach((vendor) => {
//                 row[vendor] = vendorSalesGrowth[vendor][idx] || 0;
//             });
//             return row;
//         });
//     };


//     // Prepare chart data
//     const PIE_COLORS_ORDER_STATUS = ["#4CAF50", "#F44336", "#2196F3"];
//     const PIE_COLORS_PAYMENT = ["#3498db", "#e74c3c", "#2ecc71", "#f1c40f", "#9b59b6"];

//     const topPerformingData = (stats.topPerformingVendors || []).map((vendor, index) => ({
//         name: `Vendor ${vendor.vendorId}`,
//         value: parseFloat(vendor.percentage) || 0,
//         color: PIE_COLORS_ORDER_STATUS[index % PIE_COLORS_ORDER_STATUS.length],
//     }));

//     const paymentMethodsData = (stats.paymentMethods || []).map((method, index) => ({
//         name: method.method,
//         value: parseFloat(method.percentage) || 0,
//     }));

//     const restaurantOrdersData = (stats.topPerformingVendors || []).map((vendor, index) => ({
//         name: `Vendor ${vendor.vendorId}`,
//         data: [
//             { name: "Completed", value: vendor.revenue || 0 },
//             { name: "Cancelled", value: stats.todayCancelledOrders || 0 },
//             { name: "In Progress", value: stats.todayTotalOrders - vendor.revenue || 0 },
//         ],
//     }));

//     const salesGrowthData = transformSalesGrowth(stats.vendorSalesGrowth);

//     const dynamicMainContentStyle = () => {
//         let marginLeft = "20px";
//         if (screenWidth >= 1400) marginLeft = "0px";
//         else if (screenWidth >= 1200) marginLeft = "00px";
//         else if (screenWidth >= 992) marginLeft = "100px";
//         else if (screenWidth < 768) marginLeft = "10px";
//         return { marginLeft, paddingRight: screenWidth < 768 ? "10px" : "20px", boxSizing: "border-box" };
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-2"></div>
//                 <div className="col-lg-10">
//                     <div
//                         className="analysis-page"
//                         style={{ overflowY: "auto", height: "96vh", scrollbarWidth: "none" }}
//                     >
//                         <p
//                             className="breadcrumb maamaas-home-bredcum or7"
//                             style={{
//                                 position: "fixed",
//                                 zIndex: 99,
//                                 top: "40px",
//                                 left: "1vw",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 padding: "30px 0",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 textAlign: "center",
//                                 margin: 0,
//                                 height: "60px",
//                             }}
//                         >
//                             <Link
//                                 to="/Homes"
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Home
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <span
//                                 style={{
//                                     color: "purple",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 <Link
//                                     // to="/digitalmenu&billing"
//                                     style={{
//                                         color: "purple",
//                                         fontWeight: "bold",
//                                         textDecoration: "none",
//                                     }}
//                                 >
//                                     Report_Analysis
//                                 </Link>
//                             </span>
//                             <span className="separator"> &gt; </span>
//                             <span style={{ color: "purple", fontWeight: "bold", textDecoration: "none" }}>
//                                 Food & Beverages
//                             </span>
//                         </p>

//                         <div className="analysis-container" style={dynamicMainContentStyle()}>
//                             <div className="analysis-overview-content">
//                                 <div className="analysis-status-cards-grid">
//                                     <div className="analysis-status-card">
//                                         <h3>Orders</h3>
//                                         <p>{stats.todayTotalOrders}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Revenue</h3>
//                                         <p>{stats.todayRevenue}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Customers</h3>
//                                         <p>{stats.todayCustomers}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Success rate</h3>
//                                         <p>{stats.todaySuccessRate}</p>
//                                     </div>
//                                     <div className="analysis-status-card">
//                                         <h3>Cancel/Refund</h3>
//                                         <p>{stats.todayCancelledOrders + stats.todayRefundedOrders}</p>
//                                     </div>
//                                 </div>

//                                 {/* Sales Growth Chart */}
//                                 <div className="analysis-charts-row">
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Sales Growth Chart</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <LineChart data={salesGrowthData}>
//                                                 <CartesianGrid strokeDasharray="3 3" />
//                                                 <XAxis dataKey="day" />
//                                                 <YAxis />
//                                                 <Tooltip />
//                                                 <Legend />
//                                                 {Object.keys(stats.vendorSalesGrowth).length
//                                                     ? Object.keys(stats.vendorSalesGrowth).map((vendor, idx) => (
//                                                         <Line
//                                                             key={vendor}
//                                                             type="monotone"
//                                                             dataKey={vendor}
//                                                             stroke={PIE_COLORS_ORDER_STATUS[idx % PIE_COLORS_ORDER_STATUS.length]}
//                                                             dot={{ r: 4 }}
//                                                             strokeWidth={2}
//                                                         />
//                                                     ))
//                                                     : <Line
//                                                         key="Vendor 1"
//                                                         type="monotone"
//                                                         dataKey="Vendor 1"
//                                                         stroke={PIE_COLORS_ORDER_STATUS[0]}
//                                                         dot={{ r: 4 }}
//                                                         strokeWidth={2}
//                                                     />
//                                                 }
//                                             </LineChart>
//                                         </ResponsiveContainer>

//                                     </div>

//                                     {/* Top Performing Vendors */}
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Top Performing Vendor</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <PieChart>
//                                                 <Pie
//                                                     data={topPerformingData}
//                                                     cx="50%"
//                                                     cy="50%"
//                                                     outerRadius={80}
//                                                     dataKey="value"
//                                                     label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
//                                                 >
//                                                     {topPerformingData.map((entry, index) => (
//                                                         <Cell key={`cell-top-${index}`} fill={entry.color} />
//                                                     ))}
//                                                 </Pie>
//                                                 <Tooltip />
//                                                 <Legend />
//                                             </PieChart>
//                                         </ResponsiveContainer>
//                                     </div>
//                                 </div>

//                                 {/* Payment Methods */}
//                                 <div className="analysis-charts-row">
//                                     <div className="analysis-chart-container">
//                                         <h2 className="analysis-chart-title">Most Preferred Payment</h2>
//                                         <ResponsiveContainer width="100%" height={300}>
//                                             <PieChart>
//                                                 <Pie
//                                                     data={paymentMethodsData}
//                                                     cx="50%"
//                                                     cy="50%"
//                                                     outerRadius={80}
//                                                     dataKey="value"
//                                                     label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//                                                 >
//                                                     {paymentMethodsData.map((entry, index) => (
//                                                         <Cell
//                                                             key={`cell-payment-${index}`}
//                                                             fill={PIE_COLORS_PAYMENT[index % PIE_COLORS_PAYMENT.length]}
//                                                         />
//                                                     ))}
//                                                 </Pie>
//                                                 <Tooltip />
//                                                 <Legend />
//                                             </PieChart>
//                                         </ResponsiveContainer>
//                                     </div>
//                                 </div>

//                                 {/* Orders by Vendor Pie Charts */}
//                                 <h2 className="analysis-section-title">Order Analytics by Restaurant</h2>
//                                 <div className="analysis-restaurant-pie-charts-grid">
//                                     {restaurantOrdersData.map((restaurant, index) => (
//                                         <div key={restaurant.name + index} className="analysis-pie-chart-box">
//                                             <h4 className="analysis-pie-chart-title">{restaurant.name}</h4>
//                                             <ResponsiveContainer width="100%" height={250}>
//                                                 <PieChart>
//                                                     <Pie
//                                                         data={restaurant.data}
//                                                         cx="50%"
//                                                         cy="50%"
//                                                         outerRadius={50}
//                                                         dataKey="value"
//                                                         label={({ name, value }) => `${name}: ${value}`}
//                                                     >
//                                                         {restaurant.data.map((entry, i) => (
//                                                             <Cell
//                                                                 key={`cell-res-${index}-${i}`}
//                                                                 fill={PIE_COLORS_ORDER_STATUS[i % PIE_COLORS_ORDER_STATUS.length]}
//                                                             />
//                                                         ))}
//                                                     </Pie>
//                                                     <Tooltip />
//                                                     <Legend />
//                                                 </PieChart>
//                                             </ResponsiveContainer>
//                                         </div>
//                                     ))}
//                                 </div>

//                                 {/* Recommendations */}
//                                 <div className="analysis-recommendations">
//                                     <h3 className="analysis-recommendations-title">Recommendations</h3>
//                                     <p>"Peak sales happen between 7-9PM. Consider discounts!"</p>
//                                     <p>"80% of Customers prefer online payments. Reduce COD options!"</p>
//                                     <p>"Refund Rate increased by 5%. Analyze refund reasons!"</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Foodreports;





import React, { useState, useEffect } from "react";
import "../Caterings/Analysis.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    BarChart,
    Bar,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
} from "recharts";

const Foodreports = () => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [stats, setStats] = useState(null);
    const { showLoader, hideLoader } = useLoader();
    
    // State for animations
    const [fadeIn, setFadeIn] = useState(false);
    const [cardAnimation, setCardAnimation] = useState(false);

    // Handle screen resize
    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Fetch API data
    useEffect(() => {
        const fetchStats = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                if (!token) throw new Error("No auth token found. Please login.");

                const response = await axios.get(
                    "https://backend.maamaas.com/food/api/orders/admin/statistics",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "application/json",
                        },
                    }
                );

                setStats(response.data);
                // Trigger animations after data loads
                setTimeout(() => {
                    setFadeIn(true);
                    setTimeout(() => setCardAnimation(true), 300);
                }, 100);
            } catch (err) {
                console.error("Failed to fetch statistics:", err);
            } finally {
                hideLoader();
            }
        };

        fetchStats();
    }, []);

    // Format currency in Indian Rupees
    const formatCurrency = (value) => {
        if (value === undefined || value === null) return "₹0.00";
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    };

    // Format percentage
    const formatPercentage = (value) => {
        if (!value) return "0.00%";
        if (typeof value === 'string') {
            // Remove % if present and format
            const num = parseFloat(value.replace('%', ''));
            return !isNaN(num) ? `${num.toFixed(2)}%` : "0.00%";
        }
        return `${parseFloat(value).toFixed(2)}%`;
    };

    // Calculate realistic order status distribution for each vendor
    const calculateVendorOrderAnalytics = () => {
        const vendors = stats.topPerformingVendors || [];
        const totalOrders = stats.todayTotalOrders || 0;
        const cancelledOrders = stats.todayCancelledOrders || 0;
        const refundedOrders = stats.todayRefundedOrders || 0;
        
        if (vendors.length === 0) {
            return [];
        }

        // Calculate average orders per vendor (for simulation)
        const avgOrdersPerVendor = totalOrders / vendors.length;
        
        return vendors.map((vendor, index) => {
            const vendorPercentage = parseFloat(vendor.percentage) || 0;
            
            // Calculate estimated order count for this vendor based on percentage
            const estimatedOrders = Math.round((vendorPercentage / 100) * totalOrders) || 1;
            
            // Distribute cancelled orders proportionally
            const vendorCancelledOrders = Math.round((vendorPercentage / 100) * cancelledOrders);
            
            // Calculate in-progress orders (assume 20% of orders are in progress)
            const inProgressOrders = Math.round(estimatedOrders * 0.2);
            
            // Calculate completed orders
            const completedOrders = estimatedOrders - vendorCancelledOrders - inProgressOrders;
            
            // Calculate revenue per completed order (for display)
            const avgRevenuePerOrder = vendor.revenue / Math.max(completedOrders, 1);
            
            return {
                vendorId: vendor.vendorId,
                name: `Vendor ${vendor.vendorId}`,
                data: [
                    { 
                        name: "Completed", 
                        value: completedOrders,
                        revenue: vendor.revenue || 0
                    },
                    { 
                        name: "Cancelled", 
                        value: vendorCancelledOrders,
                        revenue: 0
                    },
                    { 
                        name: "In Progress", 
                        value: inProgressOrders,
                        revenue: inProgressOrders * avgRevenuePerOrder
                    }
                ],
                totalOrders: estimatedOrders,
                successRate: ((completedOrders / estimatedOrders) * 100).toFixed(1),
                color: PIE_COLORS_ORDER_STATUS[index % PIE_COLORS_ORDER_STATUS.length]
            };
        });
    };

    if (!stats) {
        return (
            <div className="loading-skeleton" style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
            }}>
                <div style={{ 
                    textAlign: 'center',
                    opacity: fadeIn ? 1 : 0,
                    transition: 'opacity 0.5s ease'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        border: '5px solid #f3f3f3',
                        borderTop: '5px solid #4f46e5',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 20px'
                    }}></div>
                    <p style={{
                        color: '#4f46e5',
                        fontSize: '18px',
                        fontWeight: '600',
                        margin: 0
                    }}>Loading statistics...</p>
                </div>
            </div>
        );
    }

    // Prepare chart colors
    const PIE_COLORS_ORDER_STATUS = ["#4CAF50", "#F44336", "#2196F3", "#FF9800", "#9C27B0"];
    const PIE_COLORS_PAYMENT = ["#3498db", "#e74c3c", "#2ecc71", "#f1c40f", "#9b59b6"];

    // Transform vendorSalesGrowth for BarChart
    const transformSalesGrowth = () => {
        const vendorSalesGrowth = stats.vendorSalesGrowth || {};
        
        if (Object.keys(vendorSalesGrowth).length === 0) {
            return [
                { name: 'Vendor 1', growth: 0 },
                { name: 'Vendor 2', growth: 0 },
                { name: 'Vendor 3', growth: 0 }
            ];
        }

        return Object.entries(vendorSalesGrowth).map(([vendorId, growth]) => ({
            name: `Vendor ${vendorId}`,
            growth: parseFloat(growth) || 0,
        }));
    };

    // Top performing vendors data for PieChart
    const topPerformingData = (stats.topPerformingVendors || []).map((vendor, index) => ({
        name: `Vendor ${vendor.vendorId}`,
        value: parseFloat(vendor.percentage) || 0,
        color: PIE_COLORS_ORDER_STATUS[index % PIE_COLORS_ORDER_STATUS.length],
        revenue: vendor.revenue || 0,
        growth: parseFloat(vendor.salesGrowth) || 0
    }));

    // Add fallback if no top performing vendors
    if (topPerformingData.length === 0) {
        topPerformingData.push({ 
            name: 'No Data', 
            value: 100, 
            color: '#cccccc',
            revenue: 0,
            growth: 0
        });
    }

    // Payment methods data
    const paymentMethodsData = (stats.paymentMethods || []).map((method, index) => ({
        name: method.method.replace(/_/g, ' '),
        value: parseFloat(method.percentage) || 0,
        count: method.count || 0
    }));

    // Calculate order analytics for each vendor
    const vendorOrderAnalytics = calculateVendorOrderAnalytics();

    // Sales growth data
    const salesGrowthData = transformSalesGrowth();

    // Dynamic margin based on screen width
    const dynamicMainContentStyle = () => {
        let marginLeft = "20px";
        if (screenWidth >= 1400) marginLeft = "0px";
        else if (screenWidth >= 1200) marginLeft = "00px";
        else if (screenWidth >= 992) marginLeft = "100px";
        else if (screenWidth < 768) marginLeft = "10px";
        
        return { 
            marginLeft, 
            paddingRight: screenWidth < 768 ? "10px" : "20px", 
            boxSizing: "border-box",
            opacity: fadeIn ? 1 : 0,
            transform: fadeIn ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.5s ease-out'
        };
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <div
                        className="analysis-page"
                        style={{ overflowY: "auto", height: "96vh", scrollbarWidth: "none" }}
                    >
                        {/* Breadcrumb */}
                        <p
                            className="breadcrumb maamaas-home-bredcum or7"
                            style={{
                                position: "fixed",
                                zIndex: 99,
                                top: "40px",
                                left: "1vw",
                                width: "100%",
                                backgroundColor: "#fff",
                                padding: "30px 0",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                margin: 0,
                                height: "60px",
                                animation: "slideDown 0.5s ease-out"
                            }}
                        >
                            <Link
                                to="/Homes"
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                    transition: "all 0.3s ease"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.05)";
                                    e.currentTarget.style.color = "#8a2be2";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.color = "purple";
                                }}
                            >
                                Home
                            </Link>
                            <span className="separator" style={{ 
                                transition: "all 0.3s ease",
                                display: "inline-block"
                            }}> &gt; </span>
                            <span
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                <Link
                                    to="/digitalmenu&billing"
                                    style={{
                                        color: "purple",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                        transition: "all 0.3s ease"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "scale(1.05)";
                                        e.currentTarget.style.color = "#8a2be2";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "scale(1)";
                                        e.currentTarget.style.color = "purple";
                                    }}
                                >
                                    Report_Analysis
                                </Link>
                            </span>
                            <span className="separator" style={{ 
                                transition: "all 0.3s ease",
                                display: "inline-block"
                            }}> &gt; </span>
                            <span style={{ 
                                color: "purple", 
                                fontWeight: "bold", 
                                textDecoration: "none",
                                transition: "all 0.3s ease",
                                display: "inline-block"
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "scale(1.05)";
                                    e.currentTarget.style.color = "#8a2be2";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.color = "purple";
                                }}
                            >
                                Food & Beverages
                            </span>
                        </p>

                        {/* Main Content */}
                        <div className="analysis-container" style={dynamicMainContentStyle()}>
                            <div className="analysis-overview-content">
                                {/* Status Cards */}
                                <div className="analysis-status-cards-grid">
                                    {[
                                        { 
                                            title: "Total Orders", 
                                            value: stats.todayTotalOrders || 0, 
                                            delay: 0,
                                            description: "Today's total orders"
                                        },
                                        { 
                                            title: "Today's Revenue", 
                                            value: formatCurrency(stats.todayRevenue), 
                                            delay: 100,
                                            description: "Total revenue generated"
                                        },
                                        { 
                                            title: "Customers", 
                                            value: stats.todayCustomers || 0, 
                                            delay: 200,
                                            description: "Unique customers today"
                                        },
                                        { 
                                            title: "Success Rate", 
                                            value: formatPercentage(stats.todaySuccessRate), 
                                            delay: 300,
                                            description: "Order success percentage"
                                        },
                                        { 
                                            title: "Cancel/Refund", 
                                            value: (stats.todayCancelledOrders || 0) + (stats.todayRefundedOrders || 0), 
                                            delay: 400,
                                            description: "Cancelled & refunded orders"
                                        }
                                    ].map((item, index) => (
                                        <div 
                                            key={index}
                                            className="analysis-status-card"
                                            style={{
                                                opacity: cardAnimation ? 1 : 0,
                                                transform: cardAnimation ? 'translateY(0)' : 'translateY(30px)',
                                                transition: `all 0.5s ease-out ${item.delay}ms`,
                                                background: `linear-gradient(135deg, 
                                                    ${index === 0 ? '#E3F2FD, #BBDEFB' :  // Light Blue
                                                      index === 1 ? '#E8F5E9, #C8E6C9' :  // Light Green
                                                      index === 2 ? '#FFF8E1, #FFECB3' :  // Light Yellow
                                                      index === 3 ? '#F3E5F5, #E1BEE7' :  // Light Purple
                                                      '#FFEBEE, #FFCDD2'})`,            // Light Red
                                                borderRadius: '16px',
                                                padding: '24px',
                                                boxShadow: '0 6px 20px rgba(0, 0, 0, 0.08)',
                                                color: '#1a1a1a',
                                                cursor: 'pointer',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                                backdropFilter: 'blur(10px)'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.12)';
                                                e.currentTarget.style.background = `linear-gradient(135deg, 
                                                    ${index === 0 ? '#E3F2FD, #90CAF9' :  // Slightly darker on hover
                                                      index === 1 ? '#E8F5E9, #81C784' :
                                                      index === 2 ? '#FFF8E1, #FFD54F' :
                                                      index === 3 ? '#F3E5F5, #BA68C8' :
                                                      '#FFEBEE, #EF9A9A'})`;
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.08)';
                                                e.currentTarget.style.background = `linear-gradient(135deg, 
                                                    ${index === 0 ? '#E3F2FD, #BBDEFB' :
                                                      index === 1 ? '#E8F5E9, #C8E6C9' :
                                                      index === 2 ? '#FFF8E1, #FFECB3' :
                                                      index === 3 ? '#F3E5F5, #E1BEE7' :
                                                      '#FFEBEE, #FFCDD2'})`;
                                            }}
                                        >
                                            {/* Shimmer effect overlay */}
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: '-100%',
                                                width: '100%',
                                                height: '100%',
                                                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)',
                                                transition: 'left 0.7s ease'
                                            }}></div>
                                            
                                            <div style={{
                                                position: 'relative',
                                                zIndex: 2
                                            }}>
                                                <h3 style={{
                                                    margin: "0 0 12px 0",
                                                    fontSize: "16px",
                                                    fontWeight: "600",
                                                    color: "#424242",
                                                    letterSpacing: "0.5px",
                                                    transition: "all 0.3s ease"
                                                }}>{item.title}</h3>
                                                <p style={{
                                                    margin: "0 0 8px 0",
                                                    fontSize: "32px",
                                                    fontWeight: "700",
                                                    color: "#212121",
                                                    textShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                    transition: "all 0.3s ease"
                                                }}>{item.value}</p>
                                                <p style={{
                                                    margin: "0",
                                                    fontSize: "12px",
                                                    color: "#616161",
                                                    opacity: 0.9,
                                                    fontWeight: "500",
                                                    letterSpacing: "0.3px",
                                                    transition: "all 0.3s ease"
                                                }}>{item.description}</p>
                                            </div>
                                            
                                            {/* Decorative corner */}
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                width: '60px',
                                                height: '60px',
                                                background: `linear-gradient(135deg, 
                                                    ${index === 0 ? '#2196F3' :
                                                      index === 1 ? '#4CAF50' :
                                                      index === 2 ? '#FF9800' :
                                                      index === 3 ? '#9C27B0' :
                                                      '#F44336'}20`,
                                                borderBottomLeftRadius: '50px',
                                                transition: 'all 0.3s ease'
                                            }}></div>
                                            
                                            {/* Small indicator dot */}
                                            <div style={{
                                                position: 'absolute',
                                                bottom: '20px',
                                                right: '20px',
                                                width: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                background: `linear-gradient(135deg, 
                                                    ${index === 0 ? '#2196F3' :
                                                      index === 1 ? '#4CAF50' :
                                                      index === 2 ? '#FF9800' :
                                                      index === 3 ? '#9C27B0' :
                                                      '#F44336'}`,
                                                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                                                transition: 'all 0.3s ease',
                                                opacity: 0.8
                                            }}></div>
                                        </div>
                                    ))}
                                </div>

                                {/* Charts Row */}
                                <div className="analysis-charts-row">
                                    {/* Vendor Sales Growth Chart */}
                                    <div className="analysis-chart-container"
                                        style={{
                                            opacity: fadeIn ? 1 : 0,
                                            transform: fadeIn ? 'translateX(0)' : 'translateX(-20px)',
                                            transition: `all 0.6s ease-out 0.2s`,
                                            background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
                                            borderRadius: '16px',
                                            padding: '25px',
                                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                                            border: '1px solid rgba(226, 232, 240, 0.6)',
                                            backdropFilter: 'blur(10px)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-3px) translateX(0)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0) translateX(0)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                                        }}
                                    >
                                        <h2 className="analysis-chart-title" style={{
                                            fontSize: "20px",
                                            fontWeight: "600",
                                            marginBottom: "25px",
                                            color: "#1e293b",
                                            background: "linear-gradient(90deg, #4f46e5, #8b5cf6)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                        }}>Vendor Sales Growth</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart data={salesGrowthData}>
                                                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" opacity={0.7} />
                                                <XAxis 
                                                    dataKey="name" 
                                                    stroke="#64748b"
                                                    tick={{ fill: '#64748b' }}
                                                />
                                                <YAxis 
                                                    stroke="#64748b"
                                                    tick={{ fill: '#64748b' }}
                                                    tickFormatter={(value) => `${value}%`}
                                                />
                                                <Tooltip 
                                                    contentStyle={{ 
                                                        background: "rgba(255, 255, 255, 0.95)",
                                                        border: "1px solid rgba(226, 232, 240, 0.8)",
                                                        borderRadius: "12px",
                                                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                                                        backdropFilter: "blur(10px)"
                                                    }}
                                                    formatter={(value) => [`${value}%`, 'Growth']}
                                                    labelFormatter={(label) => `Vendor: ${label}`}
                                                />
                                                <Legend />
                                                <Bar 
                                                    dataKey="growth" 
                                                    name="Sales Growth %" 
                                                    fill="#8884d8"
                                                    radius={[4, 4, 0, 0]}
                                                    animationDuration={1500}
                                                    animationBegin={300}
                                                />
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </div>

                                    {/* Top Performing Vendors */}
                                    <div className="analysis-chart-container"
                                        style={{
                                            opacity: fadeIn ? 1 : 0,
                                            transform: fadeIn ? 'translateX(0)' : 'translateX(20px)',
                                            transition: `all 0.6s ease-out 0.3s`,
                                            background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
                                            borderRadius: '16px',
                                            padding: '25px',
                                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                                            border: '1px solid rgba(226, 232, 240, 0.6)',
                                            backdropFilter: 'blur(10px)'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-3px) translateX(0)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0) translateX(0)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                                        }}
                                    >
                                        <h2 className="analysis-chart-title" style={{
                                            fontSize: "20px",
                                            fontWeight: "600",
                                            marginBottom: "25px",
                                            color: "#1e293b",
                                            background: "linear-gradient(90deg, #4f46e5, #8b5cf6)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                        }}>Top Performing Vendors</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <PieChart>
                                                <Pie
                                                    data={topPerformingData}
                                                    cx="50%"
                                                    cy="50%"
                                                    outerRadius={85}
                                                    innerRadius={30}
                                                    paddingAngle={2}
                                                    dataKey="value"
                                                    label={({ name, value }) => `${name}: ${value.toFixed(1)}%`}
                                                    animationDuration={1500}
                                                    animationBegin={500}
                                                >
                                                    {topPerformingData.map((entry, index) => (
                                                        <Cell 
                                                            key={`cell-top-${index}`} 
                                                            fill={entry.color}
                                                            stroke="#ffffff"
                                                            strokeWidth={2}
                                                        />
                                                    ))}
                                                </Pie>
                                                <Tooltip 
                                                    contentStyle={{ 
                                                        background: "rgba(255, 255, 255, 0.95)",
                                                        border: "1px solid rgba(226, 232, 240, 0.8)",
                                                        borderRadius: "12px",
                                                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                                                        backdropFilter: "blur(10px)"
                                                    }}
                                                    formatter={(value, name, props) => {
                                                        const data = props.payload;
                                                        return [
                                                            `${value.toFixed(2)}%`,
                                                            <div>
                                                                <div>Revenue: {formatCurrency(data.revenue)}</div>
                                                                <div>Growth: {data.growth.toFixed(2)}%</div>
                                                            </div>
                                                        ];
                                                    }}
                                                />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                {/* Second Charts Row */}
                                <div className="analysis-charts-row">
                                    {/* Payment Methods */}
                                    <div className="analysis-chart-container"
                                        style={{
                                            opacity: fadeIn ? 1 : 0,
                                            transform: fadeIn ? 'scale(1)' : 'scale(0.95)',
                                            transition: `all 0.7s ease-out 0.4s`,
                                            background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
                                            borderRadius: '16px',
                                            padding: '25px',
                                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                                            border: '1px solid rgba(226, 232, 240, 0.6)',
                                            backdropFilter: 'blur(10px)',
                                            width: '100%'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-3px) scale(1.01)';
                                            e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.12)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                                        }}
                                    >
                                        <h2 className="analysis-chart-title" style={{
                                            fontSize: "20px",
                                            fontWeight: "600",
                                            marginBottom: "25px",
                                            color: "#1e293b",
                                            background: "linear-gradient(90deg, #4f46e5, #8b5cf6)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                        }}>Most Preferred Payment Methods</h2>
                                        <ResponsiveContainer width="100%" height={300}>
                                            <PieChart>
                                                <Pie
                                                    data={paymentMethodsData}
                                                    cx="50%"
                                                    cy="50%"
                                                    outerRadius={85}
                                                    innerRadius={30}
                                                    paddingAngle={2}
                                                    dataKey="value"
                                                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                                    animationDuration={1500}
                                                    animationBegin={700}
                                                >
                                                    {paymentMethodsData.map((entry, index) => (
                                                        <Cell
                                                            key={`cell-payment-${index}`}
                                                            fill={PIE_COLORS_PAYMENT[index % PIE_COLORS_PAYMENT.length]}
                                                            stroke="#ffffff"
                                                            strokeWidth={2}
                                                        />
                                                    ))}
                                                </Pie>
                                                <Tooltip 
                                                    contentStyle={{ 
                                                        background: "rgba(255, 255, 255, 0.95)",
                                                        border: "1px solid rgba(226, 232, 240, 0.8)",
                                                        borderRadius: "12px",
                                                        boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                                                        backdropFilter: "blur(10px)"
                                                    }}
                                                    formatter={(value, name, props) => {
                                                        const data = props.payload;
                                                        return [
                                                            `${value.toFixed(2)}%`,
                                                            `Count: ${data.count} transactions`
                                                        ];
                                                    }}
                                                />
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                {/* Order Analytics by Restaurant */}
                                <h2 className="analysis-section-title" style={{
                                    fontSize: "22px",
                                    fontWeight: "700",
                                    margin: "40px 0 25px 0",
                                    color: "#1e293b",
                                    opacity: fadeIn ? 1 : 0,
                                    transform: fadeIn ? 'translateY(0)' : 'translateY(20px)',
                                    transition: 'all 0.5s ease-out 0.5s',
                                    background: "linear-gradient(90deg, #4f46e5, #8b5cf6)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    paddingBottom: "10px",
                                    borderBottom: "3px solid",
                                    borderImage: "linear-gradient(90deg, #4f46e5, #8b5cf6) 1"
                                }}>Order Analytics by Restaurant</h2>
                                
                                <div className="analysis-restaurant-pie-charts-grid">
                                    {vendorOrderAnalytics.map((vendor, index) => (
                                        <div 
                                            key={`vendor-${vendor.vendorId}`} 
                                            className="analysis-pie-chart-box"
                                            style={{
                                                opacity: fadeIn ? 1 : 0,
                                                transform: fadeIn ? 'translateY(0)' : 'translateY(30px)',
                                                transition: `all 0.6s ease-out ${0.6 + (index * 0.1)}s`,
                                                background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
                                                borderRadius: '16px',
                                                padding: '20px',
                                                boxShadow: '0 8px 25px rgba(0, 0, 0, 0.08)',
                                                border: '1px solid rgba(226, 232, 240, 0.6)',
                                                backdropFilter: 'blur(10px)',
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-5px)';
                                                e.currentTarget.style.boxShadow = '0 15px 35px rgba(0, 0, 0, 0.12)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.08)';
                                            }}
                                        >
                                            <h4 className="analysis-pie-chart-title" style={{
                                                fontSize: "18px",
                                                fontWeight: "600",
                                                marginBottom: "15px",
                                                textAlign: "center",
                                                color: "#1e293b"
                                            }}>{vendor.name}</h4>
                                            
                                            <div style={{ 
                                                textAlign: "center", 
                                                marginBottom: "15px",
                                                padding: "10px",
                                                background: "linear-gradient(135deg, rgba(79, 70, 229, 0.05), rgba(139, 92, 246, 0.02))",
                                                borderRadius: "8px"
                                            }}>
                                                <p style={{ 
                                                    margin: "5px 0", 
                                                    fontSize: "14px",
                                                    color: "#475569"
                                                }}>
                                                    Total Orders: <strong>{vendor.totalOrders}</strong>
                                                </p>
                                                <p style={{ 
                                                    margin: "5px 0", 
                                                    fontSize: "14px",
                                                    color: "#475569"
                                                }}>
                                                    Success Rate: <strong style={{ 
                                                        color: parseFloat(vendor.successRate) >= 80 ? "#10b981" : 
                                                               parseFloat(vendor.successRate) >= 60 ? "#f59e0b" : "#ef4444"
                                                    }}>{vendor.successRate}%</strong>
                                                </p>
                                            </div>
                                            
                                            <ResponsiveContainer width="100%" height={200}>
                                                <PieChart>
                                                    <Pie
                                                        data={vendor.data}
                                                        cx="50%"
                                                        cy="50%"
                                                        outerRadius={60}
                                                        innerRadius={20}
                                                        paddingAngle={2}
                                                        dataKey="value"
                                                        label={({ name, value }) => `${name}: ${value}`}
                                                        animationDuration={1500}
                                                        animationBegin={800 + (index * 100)}
                                                    >
                                                        {vendor.data.map((entry, i) => (
                                                            <Cell
                                                                key={`cell-${vendor.vendorId}-${i}`}
                                                                fill={PIE_COLORS_ORDER_STATUS[i % PIE_COLORS_ORDER_STATUS.length]}
                                                                stroke="#ffffff"
                                                                strokeWidth={2}
                                                            />
                                                        ))}
                                                    </Pie>
                                                    <Tooltip 
                                                        contentStyle={{ 
                                                            background: "rgba(255, 255, 255, 0.95)",
                                                            border: "1px solid rgba(226, 232, 240, 0.8)",
                                                            borderRadius: "12px",
                                                            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.1)",
                                                            backdropFilter: "blur(10px)"
                                                        }}
                                                        formatter={(value, name, props) => {
                                                            const data = props.payload;
                                                            if (name === 'Completed') {
                                                                return [
                                                                    `${value} orders`,
                                                                    <div>
                                                                        <div>Completed Orders: {value}</div>
                                                                        <div>Revenue: {formatCurrency(data.revenue)}</div>
                                                                    </div>
                                                                ];
                                                            }
                                                            return [`${value} orders`, name];
                                                        }}
                                                    />
                                                    <Legend 
                                                        wrapperStyle={{ 
                                                            fontSize: "12px",
                                                            paddingTop: "10px"
                                                        }}
                                                    />
                                                </PieChart>
                                            </ResponsiveContainer>
                                            
                                            {/* Order Details List */}
                                            <div style={{ 
                                                marginTop: "15px",
                                                paddingTop: "15px",
                                                borderTop: "1px solid #e2e8f0"
                                            }}>
                                                {vendor.data.map((status, i) => (
                                                    <div key={i} style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        marginBottom: "8px",
                                                        padding: "5px 10px",
                                                        background: i % 2 === 0 ? "#f8fafc" : "transparent",
                                                        borderRadius: "6px"
                                                    }}>
                                                        <span style={{
                                                            fontSize: "14px",
                                                            color: "#475569",
                                                            fontWeight: "500"
                                                        }}>
                                                            {status.name}:
                                                        </span>
                                                        <span style={{
                                                            fontSize: "14px",
                                                            fontWeight: "600",
                                                            color: i === 0 ? "#10b981" : 
                                                                   i === 1 ? "#ef4444" : "#3b82f6"
                                                        }}>
                                                            {status.value} orders
                                                            {status.name === 'Completed' && status.revenue > 0 && (
                                                                <span style={{
                                                                    fontSize: "12px",
                                                                    color: "#64748b",
                                                                    marginLeft: "8px",
                                                                    fontWeight: "normal"
                                                                }}>
                                                                    ({formatCurrency(status.revenue)})
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Recommendations */}
                                <div className="analysis-recommendations"
                                    style={{
                                        opacity: fadeIn ? 1 : 0,
                                        transform: fadeIn ? 'translateY(0)' : 'translateY(40px)',
                                        transition: `all 0.7s ease-out 1s`,
                                        background: 'linear-gradient(145deg, #ffffff, #f8fafc)',
                                        borderRadius: '16px',
                                        padding: '30px',
                                        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                                        border: '1px solid rgba(226, 232, 240, 0.6)',
                                        backdropFilter: 'blur(10px)',
                                        marginTop: '40px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-3px)';
                                        e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.12)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.08)';
                                    }}
                                >
                                    <h3 className="analysis-recommendations-title" style={{
                                        fontSize: "20px",
                                        fontWeight: "600",
                                        marginBottom: "25px",
                                        color: "#1e293b",
                                        background: "linear-gradient(90deg, #4f46e5, #8b5cf6)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent"
                                    }}>Insights & Recommendations</h3>
                                    
                                    {[
                                        vendorOrderAnalytics.length > 0 && vendorOrderAnalytics[0].successRate > 80 
                                            ? `Vendor ${vendorOrderAnalytics[0]?.vendorId || '1'} has excellent performance with ${vendorOrderAnalytics[0]?.successRate}% success rate. Consider featuring their products!`
                                            : `Focus on improving order success rates across all vendors. Current average: ${(vendorOrderAnalytics.reduce((sum, v) => sum + parseFloat(v.successRate), 0) / vendorOrderAnalytics.length || 0).toFixed(1)}%`,
                                        
                                        stats.todayCancelledOrders > 0 
                                            ? `${stats.todayCancelledOrders} orders were cancelled today. Review cancellation reasons to improve customer retention.`
                                            : 'Great! No orders were cancelled today. Maintain this performance!',
                                        
                                        stats.salesGrowth && parseFloat(stats.salesGrowth) > 0
                                            ? `Sales growth is ${stats.salesGrowth}. Excellent momentum! Consider scaling successful strategies.`
                                            : 'Monitor sales trends closely. Consider promotional offers to boost growth.',
                                        
                                        stats.paymentMethods && stats.paymentMethods[0]
                                            ? `${stats.paymentMethods[0].method.replace('_', ' ')} is the most popular payment method (${stats.paymentMethods[0].percentage}). Optimize this payment channel for better conversion.`
                                            : 'Analyze payment method preferences to optimize checkout experience.',
                                        
                                        stats.todayCustomers > 0
                                            ? `Average order value: ${formatCurrency((stats.todayRevenue || 0) / (stats.todayCustomers || 1))}. Consider upselling strategies to increase this value.`
                                            : 'Focus on customer acquisition to increase order volume.'
                                    ].filter(Boolean).map((text, index) => (
                                        <div 
                                            key={index}
                                            style={{
                                                background: "linear-gradient(135deg, rgba(79, 70, 229, 0.1), rgba(139, 92, 246, 0.05))",
                                                padding: "18px",
                                                borderRadius: "12px",
                                                marginBottom: "15px",
                                                borderLeft: "4px solid #4f46e5",
                                                opacity: fadeIn ? 1 : 0,
                                                transform: fadeIn ? 'translateX(0)' : 'translateX(-20px)',
                                                transition: `all 0.5s ease-out ${1.2 + (index * 0.1)}s`,
                                                cursor: 'pointer'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateX(5px)';
                                                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(79, 70, 229, 0.15), rgba(139, 92, 246, 0.08))';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateX(0)';
                                                e.currentTarget.style.background = 'linear-gradient(135deg, rgba(79, 70, 229, 0.1), rgba(139, 92, 246, 0.05))';
                                            }}
                                        >
                                            <p style={{
                                                margin: "0", 
                                                color: "#475569",
                                                fontSize: "15px",
                                                lineHeight: "1.6"
                                            }}>{text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add CSS for animations */}
            <style>
                {`
                @keyframes slideDown {
                    from {
                        transform: translateY(-20px);
                        opacity: 0;
                    }
                    to {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .separator {
                    transition: transform 0.3s ease;
                }

                .separator:hover {
                    transform: scale(1.2);
                    color: #8a2be2;
                }

                .analysis-status-cards-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 20px;
                    margin-bottom: 30px;
                }

                .analysis-charts-row {
                    // display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 25px;
                    margin-bottom: 30px;
                }

                @media (max-width: 992px) {
                    .analysis-charts-row {
                        grid-template-columns: 1fr;
                    }
                }

                .analysis-restaurant-pie-charts-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
                    gap: 25px;
                    margin-bottom: 30px;
                }

                @media (max-width: 768px) {
                    .analysis-restaurant-pie-charts-grid {
                        grid-template-columns: 1fr;
                    }
                }

                /* Smooth transitions for all elements */
                * {
                    transition: background-color 0.3s ease, 
                                color 0.3s ease, 
                                transform 0.3s ease,
                                opacity 0.3s ease,
                                box-shadow 0.3s ease;
                }

                /* Shimmer effect for cards */
                .analysis-status-card:hover div:first-child {
                    left: 100%;
                }

                /* Add smooth gradient transitions */
                .analysis-status-card {
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
                }
                `}
            </style>
        </div>
    );
};

export default Foodreports;